module.exports = __webpack_public_path__ + "static/media/dp3.d647d0b4.webp";